export const getIsClipboardEnabled = () =>
  Boolean(navigator.clipboard?.writeText) && window.isSecureContext;

export const copyToClipboard = (text: string) =>
  getIsClipboardEnabled()
    ? navigator.clipboard.writeText(text)
    : Promise.resolve();
